import React from "react";
import "./PasswordInputStyle.less";
import closedEye from "../../assets/closed-eye.png"
import openedEye from "../../assets/opened-eye.png"

class PasswordInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    toggleShow = () => {
        this.setState({
            show: !this.state.show
        })
    }

    render() {
        let inputClass = ["login-control", "password-control"];
        if (this.props.error !== "") {
            inputClass.push("error");
        }
        return (
            <div className={inputClass.join(" ")}>
                <input
                    className="input-field"
                    type={this.state.show ? "text" : "password"}
                    name="login-password"
                    autoComplete={this.props.autoComplete}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    onChange={this.props.onChange}
                    onBlur={this.props.onBlur}/>
                <img className="password-span" src={this.state.show ? openedEye : closedEye} onClick={this.toggleShow} alt="password"/>
                <div className="notice-message">{this.props.error}</div>
            </div>
        );
    }
}

export default PasswordInput;